module.exports = __webpack_public_path__ + "epaper-3e2b1f4e90f956774d07.png";